import authenticationService from "../../services/authentication/authentication";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    signIn: async (context: any, payload: any) => {
      return (await authenticationService.signIn(payload)).data;
    },
    sendEmailToChangePassword: async (context: any, payload: any) => {
      return (await authenticationService.sendEmailToChangePassword(payload))
        .data;
    },
    changePassword: async (context: any, payload: any) => {
      return (await authenticationService.changePassword(payload)).data;
    }
  }
};
